import PortOpeningRuleOnPrem from "../../entities/PortOpeningRuleOnPrem";

export default class SubmitPortOpeningRequestRuleOnPrem {

	action!: string;

	operation!: string;

	sourceIPs!: string;

	sourceObjects!: string;

	sourceEnvironment!: string;

	destinationIPs!: string;

    destinationURLs!: string;

	destinationPorts!: string;

	destinationObjects!: string;

	destinationEnvironment!: string;

	description!: string;

	protocol!: string;

	ruleName: string;

	trafficDirection!: string;

	constructor(rule: PortOpeningRuleOnPrem) {
		Object.assign(this, rule);
		this.action = rule.action?.name;
		this.operation = rule.operation?.name;
		this.ruleName = rule.name;
	}
}